import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonPointService } from 'app/services/models/person-point.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assign-work-points-dialog',
  templateUrl: './assign-work-points-dialog.component.html',
  styleUrls: ['./assign-work-points-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssignWorkPointsDialogComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  selectedDate: Date = new Date();
  date = new Date();

  constructor(
    public activeModal: NgbActiveModal,
    private personPointService: PersonPointService,
    private toastrService: ToastrService
  ) { }

  public dateTimeOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: false,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y ',
    locale: Turkish,
    defaultDate: this.date
  };

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async assignWorkPoints() {
    if (!this.selectedDate) {
      alert("Lütfen bir tarih seçin.");
      return;
    }
    this.blockUI.start('Mesailer ekleniyor...');

    const selected = new Date(this.selectedDate[0]);
    selected.setHours(selected.getHours() + 4); // +4 saat ekle
  
    console.log('Gönderilecek tarih:', selected.toISOString());

    const response = await this.personPointService.assignWorkPoints(selected);
    if(response.status){
      this.toastrService.success(response.message);
      this.closeModal();
    }else{
      this.toastrService.error(response.message);
    }
  }
}
